module.exports = __webpack_public_path__ + "static/img/008.8bd02565.jpg";